module.exports = __webpack_public_path__ + "static/media/flag.8349ba55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/flag.svg
// module id = 1058
// module chunks = 0